export const doubleImageAnimationSetup = (gsap, ScrollTrigger) => {
    return window.addEventListener('DOMContentLoaded', () => {
        console.debug('Double image script loaded');
        const doubleImages = document.querySelectorAll('.spv-campaignPage__subcontainer-images');
        if (!doubleImages)
            return;
        doubleImages.forEach(doubleImage => {
            console.log(doubleImage);
            const imgItems = doubleImage.querySelectorAll('figure');
            if (imgItems.length !== 2)
                return;
            const mm = gsap.matchMedia();
            mm.add('(min-width: 1280px)', () => {
                gsap
                    .timeline({
                    scrollTrigger: {
                        trigger: doubleImage,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true,
                    },
                })
                    .fromTo(imgItems[0], {
                    y: '5%',
                }, {
                    y: '-5%',
                    ease: 'none',
                }, 0)
                    .fromTo(imgItems[1], {
                    y: '-5%',
                }, {
                    y: '5%',
                    ease: 'none',
                }, 0);
            });
        });
    });
};
//# sourceMappingURL=double-image.js.map